import {
  addDoc,
  collection,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  doc,
} from 'firebase/firestore';

import { db } from '@/config/firebase';

export type PartnerInquiry = {
  id?: string;
  name: string;
  email: string;
  company?: string;
  phone?: string;
  message?: string;
  createdAt?: any;
  status?: 'new' | 'contacted' | 'qualified' | 'closed';
};

class InquiryService {
  static async createPartnerInquiry(payload: Omit<PartnerInquiry, 'id' | 'createdAt' | 'status'>) {
    const ref = collection(db, 'partnerInquiries');
    return addDoc(ref, {
      ...payload,
      createdAt: serverTimestamp(),
      status: 'new',
    });
  }

  static async getPartnerInquiries(): Promise<PartnerInquiry[]> {
    const ref = collection(db, 'partnerInquiries');
    const q = query(ref, orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((d) => ({ id: d.id, ...(d.data() as any) }));
  }

  static async updateInquiryStatus(inquiryId: string, status: PartnerInquiry['status']) {
    const ref = doc(db, 'partnerInquiries', inquiryId);
    await updateDoc(ref, { status });
  }
}

export default InquiryService;
